import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Alert, Button, Container } from 'reactstrap';
import axiosInstance from '../../services/api_helper';
import BCForm from '../Devis/BCForm';
import BonLivraisonForm from '../BonLivraison/BonLivraisonForm';

export default function SalesDocumentPage({ delivery = false }) {
    const { id } = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const [document, setDocument] = useState(null);
    const [loading, setLoading] = useState(Boolean(id));
    const [error, setError] = useState('');
    const [retry, setRetry] = useState(0);
    const base = location.pathname.startsWith('/sales-module')
        ? `/sales-module/${delivery ? 'delivery' : 'orders'}`
        : delivery ? '/deliveryNotes/history' : '/commandes';
    const close = () => navigate(base);
    useEffect(() => {
        let active = true;
        setDocument(null);
        setError('');
        setLoading(Boolean(id));
        if (id) axiosInstance.get(`/api/ventes/${delivery ? 'bon-livraison' : 'bon-commande'}/${id}`)
            .then(response => { if (active) setDocument(response.data.body); })
            .catch(() => { if (active) setError('Impossible de charger le document.'); })
            .finally(() => { if (active) setLoading(false); });
        return () => { active = false; };
    }, [id, delivery, retry]);
    return <Container fluid className="py-3">
        <div className="d-flex justify-content-between align-items-center mb-3">
            <h4>{id ? `Modifier ${delivery ? 'la livraison' : 'la commande'}${document?.numero ? ` · ${document.numero}` : ''}` : delivery ? 'Nouveau bon de livraison' : 'Nouvelle commande'}</h4>
            <Button color="light" onClick={close}>Retour à la liste</Button>
        </div>
        {loading && <p role="status">Chargement…</p>}
        {error && <Alert color="danger">{error} <Button size="sm" onClick={() => setRetry(value => value + 1)}>Réessayer</Button></Alert>}
        {!loading && !error && (!id || String(document?.id) === String(id)) && (delivery
            ? <BonLivraisonForm key={id || 'new'} bonLivraison={id ? document : null} onClose={close} />
            : <BCForm key={id || 'new'} commande={id ? document : null} onClose={close} />)}
    </Container>;
}
